import React from 'react';

const SignupConfirm  = () => {

    return (
        <div className="col-lg-7">

            <h4 className="mb-4">
                Thanks for signing up 🎉
            </h4>

            <div className="connect-page-msg message my-4">
                Your free trial will expire in 7 days. During this time, you'll have unlimited access to all features, including unlimited comments.
            </div>

            <a href="/" className="btn btn-primary">Get started</a>
        </div>
    )
}

export default SignupConfirm;